<template>
  <base-row
    v-bind="$props"
    :selectable="true"
  >
    <td>
      <Link
        v-if="hasRoute"
        :href="showCustomerRoute"
        class="text-base font-medium text-blue-600 hover:text-blue-600"
      >
        {{ item.name }}
      </Link>
      <span
        v-else
        class="text-blue-600 hover:text-blue-600"
      >
        {{ item.name }}
      </span>
    </td>
    <td>
      {{ _time(item.checked_in_at) }}
    </td>
    <td>
      {{ item.patient_number || 'NA' }}
    </td>
    <td>
      {{ item.remaining_allotment ? `${item.remaining_allotment}g` : 'NA' }}
    </td>
    <td>
      {{ checkInStatus }}
    </td>
    <td>
      <CheckCircleIcon
        v-if="item.is_veteran"
        class="h-5 w-5 text-blue-600"
        aria-hidden="true"
      />
    </td>
    <td>
      <CheckCircleIcon
        v-if="item.has_industry_discount"
        class="h-5 w-5 text-blue-600"
        aria-hidden="true"
      />
    </td>
    <td>
      <CheckCircleIcon
        v-if="item.has_loyalty"
        class="h-5 w-5 text-blue-600"
        aria-hidden="true"
      />
    </td>
    <td>
      <a
        href="#"
        @click.prevent="removeCustomer(item)"
        ><MinusCircleIcon
          class="h-5 w-5 text-red-400"
          aria-hidden="true"
      /></a>
    </td>
    <td>
      <a
        href="#"
        @click.prevent="markReady(item)"
        class="font-sm text-blue-600 flex"
      >
        <BellIcon
          v-if="!item.check_in_ready_at"
          class="h-5 w-5 mr-1 text-blue-600"
          aria-hidden="true"
        />
        <CheckCircleIcon
          v-else
          class="h-5 w-5 mr-1 text-blue-600"
          aria-hidden="true"
        />
        <span>Ready</span>
      </a>
    </td>
  </base-row>
</template>

<script>
import { Link } from '@inertiajs/vue3'
import TableRow from '@/Components/Table/TableRow'
import RowProps from '@/Components/Table/Mixins/RowProps'
import BasicBadge from '@/Components/Badges/BasicBadge.vue'
import _datetime from '@/Filters/DateTime'
import _dollars from '@/Filters/Dollars'
import { CheckCircleIcon, MinusCircleIcon, BellIcon } from '@heroicons/vue/solid'
import _time from '@/Filters/Time'

export default {
  components: {
    'base-row': TableRow,
    Link,
    BasicBadge,
    CheckCircleIcon,
    MinusCircleIcon,
    BellIcon
  },

  mixins: [RowProps],

  props: {
    /**
     * A function that we can use to generate the URL to view a package. Returns a string that is a valid URL
     */
    showRoute: {
      type: Function,
      default: (item) => null
    }
  },

  computed: {
    /**
     * Returns the URL we can use to view a package
     */
    showCustomerRoute() {
      return this.showRoute(this.item)
    },

    /**
     * Returns true if this package has a valid URL to view a package
     * @returns {boolean}
     */
    hasRoute() {
      return this.showCustomerRoute !== null
    },

    checkInStatus() {
      if (this.item.check_in_ready_at) {
        return 'Ready'
      }

      return 'Waiting'
    }
  },
  methods: {
    _datetime,
    _dollars,
    _time,

    removeCustomer(customer) {
      this.$emit('remove', customer)
    },
    markReady(customer) {
      this.$emit('ready', customer)
    }
  }
}
</script>

<style scoped>
td:nth-child(7),
td:nth-child(8),
td:nth-child(9),
td:nth-child(10) {
  text-align: center;
}

td:nth-child(7) svg,
td:nth-child(8) svg,
td:nth-child(9) svg,
td:nth-child(10) svg {
  margin: 0 auto;
}
</style>
